import React, { useState } from 'react';
import { supabase } from './supabase';

const C = {
  purple:"#691FB1", purpleLight:"#EDE7F6", green:"#27AE60", greenLight:"#EAFAF1",
  red:"#C0392B", redLight:"#FDECEA", white:"#FFFFFF", text:"#1A1A2E",
  textLight:"#8888AA", border:"#E4DEFA", bg:"#F7F5FC",
};

const MESES = { '01':'janeiro','02':'fevereiro','03':'março','04':'abril','05':'maio','06':'junho','07':'julho','08':'agosto','09':'setembro','10':'outubro','11':'novembro','12':'dezembro' };
const fmtMes = (m) => { if(!m||m.length<7) return m||''; const [y,mm]=m.split('-'); return `${MESES[mm]||mm} de ${y}`; };

// descodifica base64 UTF-8 (nomes com acentos)
const deB64 = (s) => { try { return decodeURIComponent(escape(atob(s))); } catch { return ''; } };

export default function ConfirmarRecibo() {
  const params = new URLSearchParams(window.location.search);
  const profissional = deB64(params.get('p') || '');
  const mes = params.get('m') || '';

  const [modo, setModo] = useState(null);       // null | 'errado'
  const [detalhe, setDetalhe] = useState('');
  const [ficheiro, setFicheiro] = useState(null);
  const [entidade, setEntidade] = useState(null);   // 'Workwell' | 'WeCareOn'
  const [enviando, setEnviando] = useState(false);
  const [feito, setFeito] = useState(null);     // 'correto' | 'errado'
  const [erro, setErro] = useState('');

  const submeter = async (estado) => {
    if (estado === 'errado' && !detalhe.trim()) { setErro('Descreve o que está errado, por favor.'); return; }
    if (ficheiro && ficheiro.size > 8 * 1024 * 1024) { setErro('O ficheiro é demasiado grande (máx. 8 MB).'); return; }
    if (ficheiro && !entidade) { setErro('Indica se o recibo é passado à Workwell ou à WeCareOn.'); return; }
    setEnviando(true); setErro('');
    let ficheiroPath = null;
    if (ficheiro) {
      const ext = (ficheiro.name.split('.').pop() || 'pdf').toLowerCase().replace(/[^a-z0-9]/g,'') || 'pdf';
      const safeNome = profissional.normalize('NFD').replace(/[^\w\s-]/g,'').trim().replace(/\s+/g,'_');
      ficheiroPath = `${mes}/${safeNome}_${Date.now()}.${ext}`;
      const { error: upErr } = await supabase.storage.from('recibos').upload(ficheiroPath, ficheiro, { upsert: false });
      if (upErr) {
        console.error('Upload recibo falhou:', upErr);
        setEnviando(false);
        setErro(`Não foi possível carregar o ficheiro${upErr?.message ? ` — ${upErr.message}` : ''}. Tenta novamente ou envia para financeiro@workwell.pt.`);
        return;
      }
    }
    const { data, error } = await supabase.functions.invoke('confirmar-recibo', {
      body: { professional: profissional, mes, estado, detalhe: detalhe.trim() || null, ficheiro_path: ficheiroPath, entidade: ficheiro ? entidade : null }
    });
    setEnviando(false);
    if (error || (data && data.error)) { setErro('Não foi possível registar. Tenta novamente ou contacta a Workwell.'); return; }
    setFeito(estado);
  };

  const CampoRecibo = () => (
    <div style={{ margin:'0 0 14px', background:'#F7F5FC', border:`1px dashed ${C.purple}55`, borderRadius:10, padding:'12px 14px' }}>
      <label style={{ fontSize:12, fontWeight:700, color:C.purple, display:'block', marginBottom:6 }}>A quem é passado este recibo?</label>
      <div style={{ display:'flex', gap:8, marginBottom:10 }}>
        {['Workwell','WeCareOn'].map(en=>(
          <button key={en} type="button" onClick={()=>setEntidade(en)}
            style={{ flex:1, padding:'9px 6px', borderRadius:8, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontSize:13, fontWeight:700,
              border:`2px solid ${entidade===en?C.purple:C.border}`, background:entidade===en?C.purpleLight:C.white, color:entidade===en?C.purple:C.textLight }}>
            {entidade===en?'✓ ':''}{en}
          </button>
        ))}
      </div>
      <div style={{ fontSize:11, color:C.textLight, marginBottom:8 }}>Sessões de empresas → Workwell · Sessões de particulares → WeCareOn. Se tens recibos para as duas, submete um de cada vez (podes voltar a abrir este link).</div>
      <label style={{ fontSize:12, fontWeight:700, color:C.purple, display:'block', marginBottom:6 }}>📄 Anexa o teu recibo (PDF ou foto)</label>
      <input type="file" accept=".pdf,image/*" onChange={e=>setFicheiro(e.target.files?.[0]||null)}
        style={{ fontSize:12, fontFamily:"'DM Sans',sans-serif", width:'100%' }}/>
      {ficheiro && <div style={{ fontSize:11, color:C.textLight, marginTop:5 }}>{ficheiro.name} · {(ficheiro.size/1024/1024).toFixed(1)} MB</div>}
      <div style={{ fontSize:11, color:C.textLight, marginTop:5 }}>O recibo segue diretamente para a contabilidade da entidade que escolheres.</div>
    </div>
  );

  if (!profissional || !mes) {
    return (
      <div style={{ minHeight:'100vh', background:C.bg, display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'DM Sans',sans-serif" }}>
        <div style={{ color:C.textLight, fontSize:14 }}>Link inválido. Contacta a Workwell.</div>
      </div>
    );
  }

  return (
    <div style={{ minHeight:'100vh', background:C.bg, display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'DM Sans',sans-serif", padding:16 }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Fraunces:wght@700&display=swap" rel="stylesheet"/>
      <div style={{ background:C.white, borderRadius:16, padding:36, width:460, maxWidth:'94vw', boxShadow:'0 8px 40px rgba(105,31,177,0.12)' }}>
        <h1 style={{ margin:'0 0 6px', fontFamily:"'Fraunces',serif", color:C.purple, fontSize:20, textAlign:'center' }}>Confirmação de recibo</h1>
        <p style={{ margin:'0 0 22px', color:C.textLight, fontSize:13, textAlign:'center' }}>
          {profissional} · {fmtMes(mes)}
        </p>

        {feito ? (
          <div style={{ background:feito==='correto'?C.greenLight:C.redLight, borderRadius:12, padding:'22px 18px', textAlign:'center' }}>
            <div style={{ fontSize:30, marginBottom:8 }}>{feito==='correto'?'✅':'📩'}</div>
            <div style={{ fontSize:14, fontWeight:700, color:feito==='correto'?C.green:C.red, marginBottom:4 }}>
              {feito==='correto' ? 'Recibo confirmado — obrigado!' : 'Registado — vamos verificar.'}
            </div>
            <div style={{ fontSize:12, color:C.textLight }}>
              {feito==='correto'
                ? (ficheiro ? `O teu recibo foi enviado à contabilidade (${entidade}). Não precisas de fazer mais nada.` : 'Não te esqueças de enviar o recibo para financeiro@workwell.pt.')
                : 'A equipa Workwell vai analisar o teu comentário e entrará em contacto se necessário.'}
            </div>
          </div>
        ) : (
          <>
            <p style={{ margin:'0 0 18px', color:C.text, fontSize:13, textAlign:'center' }}>
              Recebeste o resumo de pagamento deste mês. Os valores estão corretos?
            </p>
            {!modo && (
              <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                <button onClick={()=>setModo('recibo')} disabled={enviando}
                  style={{ width:'100%', padding:'14px', background:C.green, border:'none', borderRadius:10, color:'#fff', fontSize:15, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                  ✓ Está tudo correto
                </button>
                <button onClick={()=>setModo('errado')} disabled={enviando}
                  style={{ width:'100%', padding:'14px', background:C.white, border:`2px solid ${C.red}`, borderRadius:10, color:C.red, fontSize:15, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                  ✗ Há algo errado
                </button>
              </div>
            )}
            {modo==='recibo' && (
              <div>
                <p style={{ margin:'0 0 12px', color:C.text, fontSize:13, textAlign:'center', fontWeight:700 }}>Ótimo! Agora anexa o teu recibo para enviarmos ao financeiro:</p>
                <CampoRecibo/>
                <div style={{ display:'flex', gap:8 }}>
                  <button onClick={()=>{setModo(null);setFicheiro(null);setErro('');}} style={{ flex:1, padding:'12px', border:`1px solid ${C.border}`, borderRadius:8, background:C.white, color:C.textLight, fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Voltar</button>
                  <button onClick={()=>submeter('correto')} disabled={enviando||!ficheiro||!entidade}
                    style={{ flex:2, padding:'12px', border:'none', borderRadius:8, background:(!ficheiro||!entidade)?'#A9DFBF':C.green, color:'#fff', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                    {enviando ? 'A enviar…' : '📄 Enviar recibo e confirmar'}
                  </button>
                </div>
                <button onClick={()=>submeter('correto')} disabled={enviando}
                  style={{ width:'100%', marginTop:10, padding:'8px', background:'none', border:'none', color:C.textLight, fontSize:12, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", textDecoration:'underline' }}>
                  Ainda não tenho o recibo — confirmo agora e envio-o mais tarde
                </button>
              </div>
            )}
            {modo==='errado' && (
              <div>
                <CampoRecibo/>
                <label style={{ fontSize:12, fontWeight:700, color:C.red, display:'block', marginBottom:6 }}>O que está errado? (obrigatório)</label>
                <textarea value={detalhe} onChange={e=>setDetalhe(e.target.value)} rows={4} autoFocus
                  placeholder="Ex.: faltam as sessões de dia 14 e 21; o valor da sessão devia ser 25€ e está 20€…"
                  style={{ width:'100%', boxSizing:'border-box', padding:'10px 12px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:13, fontFamily:"'DM Sans',sans-serif", resize:'vertical' }}/>
                <div style={{ display:'flex', gap:8, marginTop:12 }}>
                  <button onClick={()=>{setModo(null);setErro('');}} style={{ flex:1, padding:'12px', border:`1px solid ${C.border}`, borderRadius:8, background:C.white, color:C.textLight, fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Voltar</button>
                  <button onClick={()=>submeter('errado')} disabled={enviando||!detalhe.trim()}
                    style={{ flex:2, padding:'12px', border:'none', borderRadius:8, background:!detalhe.trim()?'#E8B4AC':C.red, color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                    {enviando ? 'A registar…' : 'Enviar'}
                  </button>
                </div>
              </div>
            )}
            {erro && <div style={{ marginTop:12, background:C.redLight, borderRadius:8, padding:'9px 12px', fontSize:12, color:C.red }}>{erro}</div>}
          </>
        )}
      </div>
    </div>
  );
}
